import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from 'src/app/shared/shared.module';
import { StoreService } from 'src/app/shared/resolvers/store.service';
import { UserDetailsResolver } from 'src/app/shared/resolvers/user-details.service';
import { FeatureTagResolver } from 'src/app/shared/resolvers/feature-tag.resolver';
import { VerifyTokenGuard } from 'src/app/shared/guard/verify-token.guard';
import { LoggedInAuthGuard } from 'src/app/shared/guard/logged-in-auth.guard';
import { NotFoundComponent } from '../global-theme/pages/not-found/not-found.component';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
import { SignInUpRedirectModule } from '../global-theme/pages/sign-in/sign-in-up-redirect/sign-in-up-redirect.module';
//pages
import { HomePageComponent } from './pages/home-page/home-page.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { TheFarmStoreComponent } from './pages/the-farm-store/the-farm-store.component';
import { HomeDeliveryAndPickUpInformationComponent } from './pages/home-delivery-and-pick-up-information/home-delivery-and-pick-up-information.component';
import { CsaBoxInformationComponent } from './pages/csa-box-information/csa-box-information.component';
import { OlivorHeaderComponent } from './header/header.component';
import { OlivorFooterComponent } from './footer/footer.component';



export const OLIVOR_ROUTES: Routes = [
    {
        path: 'index',
        component: HomePageComponent,
        data: { title: 'Home', cms: 'pages' },
        resolve: { store: StoreService, featureTag: FeatureTagResolver },
    },
    {path:'',
        children: [
            {
                path: '',
                resolve: { featureTag: FeatureTagResolver },
                loadChildren: () => import('../global-theme/pages/products/products.module').then(m => m.ProductsModule),
                data: { breadcrumb: 'All Categories', title: 'All Categories' },
                canActivate: [VerifyTokenGuard],

            },
            {
                path: 'sign-up',
                loadChildren: () => import('../global-theme/pages/registration/registration.module').then(m => m.Registration),
                data: { breadcrumb: 'Sign In ', title: 'Sign In / Sign Up' },
                canActivate: [VerifyTokenGuard, LoggedInAuthGuard],
                resolve: { featureTag: FeatureTagResolver }
            },
            {
                path: 'sign-in',
                loadChildren: () => import('../global-theme/pages/sign-in/sign-in.module').then(m => m.SignInModule),
                data: { breadcrumb: 'Sign In ', title: 'Sign In / Sign Up' },
                canActivate: [VerifyTokenGuard, LoggedInAuthGuard],
                resolve: { featureTag: FeatureTagResolver }
            },
            {
                path: 'account',
                loadChildren: () => import('../global-theme/pages/account/account.module').then(m => m.AccountModule),
                resolve: { store: StoreService },
                canActivate: [VerifyTokenGuard, AuthGuard]
            },
            {
                path: 'compare',
                loadChildren: () => import('../global-theme/pages/compare/compare.module').then(m => m.CompareModule), data: { breadcrumb: 'Compare' },
                canActivate: [VerifyTokenGuard]
            },
            {
                path: 'wishlist',
                loadChildren: () => import('../global-theme/pages/wishlist/wishlist.module').then(m => m.WishlistModule), data: { breadcrumb: 'Wishlist' },
                canActivate: [VerifyTokenGuard]
            },
            {
                path: 'edit-order',
                loadChildren: () => import('src/app/shared/cart/cart.module').then(m => m.CartModule),
                data: { breadcrumb: 'Cart', title: 'Cart' },
                canActivate: [VerifyTokenGuard]
            },
            {
                path: 'pre-cart',
                loadChildren: () => import('src/app/shared/cart/pre-cart/pre-cart.module').then(m => m.PreCartModule),
                data: { breadcrumb: 'Advance Booking', title: 'Advance Booking' },
                canActivate: [VerifyTokenGuard]
            },
            {
                path: 'checkout',
                loadChildren: () => import('../global-theme/pages/checkout/checkout.module').then(m => m.CheckoutModule), data: { breadcrumb: 'Checkout' },
                canActivate: [VerifyTokenGuard]
            },
            {
                path: 'contact',
                loadChildren: () => import('./pages/contact/contact.module').then(m => m.ContactModule),
                data: { breadcrumb: 'Contact', title: 'Contact' },
                canActivate: [VerifyTokenGuard]
            },
            {
                path: 'forgot-password',
                loadChildren: () => import('../global-theme/pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
                data: { breadcrumb: 'Forgot Password', title: 'Forgot Password' },
                canActivate: [VerifyTokenGuard, LoggedInAuthGuard] 
            },
            {
                path: 'reset-password',
                loadChildren: () => import('../global-theme/pages/reset-password/reset-password.module').then(m => m.ResetPasswordModule),
                data: { breadcrumb: 'Account Creation', title: 'Account Creation' },
                canActivate: [VerifyTokenGuard, LoggedInAuthGuard]
            },
            {
                path: 'reset-password-customer',
                loadChildren: () => import('../global-theme/pages/reset-password-customer/reset-password-customer.module').then(m => m.ResetPasswordCustomerModule),
                data: { breadcrumb: 'Reset Password', title: 'Reset Password' },
                canActivate: [VerifyTokenGuard, LoggedInAuthGuard]
            },
            {
                path: 'brands',
                loadChildren: () => import('../global-theme/pages/brands/brands.module').then(m => m.BrandsModule),
                data: { breadcrumb: 'Brands', title: 'Brands' },
                canActivate: [VerifyTokenGuard]
            },
            {
                path: 'vendors',
                loadChildren: () => import('../global-theme/pages/vendors/vendors.module').then(m => m.VendorsModule),
                data: { breadcrumb: 'Vendors', title: 'Vendors', cms: 'pages' },
                canActivate: [VerifyTokenGuard],
                resolve: { featureTag: FeatureTagResolver }
            },
            {
                path: 'producers',
                loadChildren: () => import('../global-theme/pages/vendors/vendors.module').then(m => m.VendorsModule),
                data: { breadcrumb: 'Producers', title: 'Producers', cms: 'pages' },
                canActivate: [VerifyTokenGuard],
                resolve: { featureTag: FeatureTagResolver }
            },
            {
                path: 'membership-purchase',
                loadChildren: () => import('../global-theme/pages/membership-confirm/membership-confirm.module').then(m => m.MembershipModule),
                canActivate: [VerifyTokenGuard],
            },
            { path: 'about', component: AboutUsComponent, data: { title: 'About Us', cms: 'pages' } },
            { path: 'the-farm-store', component: TheFarmStoreComponent, data: { title: 'Our Services', cms: 'pages' } },
            { path: 'home-delivery-and-pick-up-information', component: HomeDeliveryAndPickUpInformationComponent, data: { title: 'Our Services', cms: 'pages' } },
            { path: 'csa-box-information', component: CsaBoxInformationComponent, data: { title: 'Our Services', cms: 'pages' } }
           

        ]
    },
    { path: '**', component: NotFoundComponent, data: { title: 'Not Found' } }
];
@NgModule({
    declarations: [
        OlivorHeaderComponent,
        OlivorFooterComponent,
        HomePageComponent, 
        AboutUsComponent,  
        TheFarmStoreComponent, 
        HomeDeliveryAndPickUpInformationComponent,
        CsaBoxInformationComponent  
    ],
    imports: [
        CommonModule,
        SharedModule,
        SignInUpRedirectModule,
        RouterModule.forChild(OLIVOR_ROUTES),
    ],
    exports: [
       
    ]
})
export class OlivorPagesModule { }
